<div fxLayout="column" fxLayoutAlign="center center" *ngIf="markupLoading || pricingLoading">
  <mat-spinner diameter="80"></mat-spinner>
</div>

<div fxLayout="column" fxLayoutGap="32px" *ngIf="!markupLoading && !pricingLoading">
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="16px" style="margin-bottom: 24px">
    <div fxLayout="row" fxLayoutAlign="center center" class="nomargin" fxLayoutGap="8px">
      <h2 class="nomargin">Set your markup rate</h2>
      <span
        fxLayout="row"
        fxLayoutAlign="center center"
        matTooltipClass="tooltip-dark tooltip-large"
        matTooltipPosition="right"
        [matTooltip]="
          'Setting a Markup is required to push rates\r\n' +
          '• If we pull in your BDC rates when your markup is greater than 0, your rates in Hospitable.com will be lower\r\n' +
          '• You can override this markup rate on a per-listing basis from the Properties page'
        ">
        <sbnb-icon icon="help" class="text-raspberry"></sbnb-icon>
      </span>
    </div>

    <p>
      When updating prices from the {{ 'CORE.PRODUCT_NAME' | transloco }} calendar the platform markup will be
      automatically added to the price.
    </p>

    <div class="markup-container" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
      <div fxFlex fxLayout="column">
        <div fxLayout fxLayoutAlign="start center">
          <strong>Booking.com</strong>
        </div>
        <div class="night-lighter text__small">Your Booking.com markup rate</div>
      </div>
      <mat-form-field>
        <input matInput [(ngModel)]="markup" type="tel" maxlength="6" [placeholder]="placeholder_markup" />
        <span matSuffix>%</span>
      </mat-form-field>
    </div>
  </div>

  <div
    fxLayout="column"
    fxLayoutAlign="start start"
    fxLayoutGap="16px"
    style="margin-bottom: 24px"
    *ngIf="propertiesResponse.length > 0">
    <h2 class="nomargin">Occupancy based pricing settings</h2>
    <p>Some of your rate plans must be updated in order to connect.</p>

    <div class="row-container properties-container full-width">
      <div fxHide.lt-lg fxLayout fxLayoutGap="20px">
        <div fxFlex="36px"></div>
        <div fxFlex=""></div>
        <div fxFlex="150px" class="text__small">Primary rate plan</div>
        <div fxFlex="100px" class="text__small">Extra guest fee</div>
        <div fxFlex="100px" class="text__small">Guests included</div>
        <div fxFlex="100px" class="text__small">Max occupancy</div>
      </div>

      <ng-container *ngFor="let property of propertiesResponse; let pIndex = index; trackBy: trackByAccount">
        <div fxHide.lt-lg>
          <!-- Parent property/channel -->
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="20px" class="property-row">
            <div fxFlex="0 0 36px" fxFlex.lt-lg="0 0 36px">
              <img
                [src]="property.image ? property.image : '/assets/images/image-error.png'"
                class="property__img"
                fxHide.lt-sm
                style="width: 36px; height: 36px" />
            </div>

            <!-- Desktop: name -->
            <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
              <span fxLayout="column" fxLayoutAlign="start start">
                <span>
                  <strong>{{ property.name }}</strong>
                </span>
                <span class="night text__small clamp">{{ property.address }}</span>
              </span>
            </div>

            <div fxFlex="150px"></div>
            <div fxFlex="100px"></div>
            <div fxFlex="100px"></div>
            <div fxFlex="100px"></div>
          </div>

          <!-- Individual listings/properties -->
          <div
            fxLayout
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
            class="listing-row"
            *ngFor="let listing of property.listings; let lIndex = index">
            <!-- No image -->
            <div fxFlex="0 0 36px" fxFlex.lt-lg="0 0 36px" class="text-right">
              <span class="child-arrow" style="font-size: 20px">↳</span>
            </div>

            <div fxFlex="" fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
              <span class="ellipsis">{{ listing.name }}</span>
            </div>

            <!-- Desktop: rate plan -->
            <div fxFlex="150px">
              <span fxLayout fxLayoutAlign="start center" fxLayoutGap="6px">
                <mat-form-field class="input__mini fw nopadding nomargin">
                  <mat-select
                    [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].ratePlanUuid"
                    (ngModelChange)="onRatePlanChange($event, pIndex, lIndex)"
                    placeholder="Select">
                    <mat-option *ngFor="let rate_plan of listing.rate_plans" [value]="rate_plan.uuid">
                      {{ rate_plan.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
            </div>

            <div fxFlex="100px">
              <mat-form-field class="input__mini fw nopadding nomargin">
                <input
                  matInput
                  type="number"
                  maxlength="6"
                  autocomplete="off"
                  [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].extraGuestFee"
                  [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                  [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                  #extraGuestFeeDesktop="ngModel" />
                <span matSuffix>{{ listing.currency }}</span>
              </mat-form-field>
            </div>
            <div fxFlex="100px">
              <mat-form-field class="input__mini fw nopadding nomargin">
                <input
                  matInput
                  type="number"
                  maxlength="2"
                  min="1"
                  autocomplete="off"
                  [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].guestsIncluded"
                  [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                  [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                  #guestsIncludedDesktop="ngModel" />
                <span matSuffix>Guests</span>
              </mat-form-field>
            </div>
            <div fxFlex="100px">
              <mat-form-field class="input__mini fw nopadding nomargin">
                <input
                  matInput
                  type="number"
                  maxlength="2"
                  min="1"
                  autocomplete="off"
                  [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].maxOccupancy"
                  [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                  [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                  #maxOccupancyDesktop="ngModel" />
                <span matSuffix>Guests</span>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Mobile -->
        <div fxHide fxShow.lt-lg fxLayout="column">
          <!-- Parent property/channel -->
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="20px" class="property-row">
            <div fxFlex="0 0 36px" fxFlex.lt-lg="0 0 36px">
              <img
                [src]="property.image ? property.image : '/assets/images/image-error.png'"
                class="property__img"
                style="width: 36px; height: 36px" />
            </div>
            <div fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
              <span fxLayout="column" fxLayoutAlign="start start">
                <span>
                  <strong>{{ property.name }}</strong>
                </span>
                <span class="night text__small clamp">{{ property.address }}</span>
              </span>
            </div>
          </div>

          <!-- Individual listings/properties -->
          <mat-expansion-panel
            *ngFor="let listing of property.listings; let lIndex = index"
            [expanded]="true"
            [hideToggle]="true">
            <mat-expansion-panel-header class="non-collapsible">
              <mat-panel-title>
                <div fxLayout fxLayoutAlign="start center" fxLayoutGap="20px">
                  <div fxFlex="0 0 36px" fxFlex.lt-lg="0 0 36px" class="text-right">
                    <span class="child-arrow" style="font-size: 20px">↳</span>
                  </div>

                  <div fxFlex="" fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
                    <span class="ellipsis">{{ listing.name }}</span>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-expansion-panel-body fxLayout fxLayoutAlign="start center" fxLayoutGap="20px">
              <div fxFlex="0 0 36px" fxFlex.lt-lg="0 0 36px" class="text-right">
                <span class="child-arrow" style="font-size: 20px">&nbsp;</span>
              </div>

              <div fxFlex fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div fxFlex fxLayout="column" fxLayoutAlign="start center" class="full-width">
                  <mat-form-field class="fw nopadding nomargin">
                    <mat-label>Primary rate plan</mat-label>
                    <mat-select
                      [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].ratePlanUuid"
                      (ngModelChange)="onRatePlanChange($event, pIndex, lIndex)"
                      placeholder="Select">
                      <mat-option *ngFor="let rate_plan of listing.rate_plans" [value]="rate_plan.uuid">
                        {{ rate_plan.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div
                  fxFlex
                  fxLayout="row"
                  fxLayout.lt-sm="column"
                  fxLayoutGap="10px"
                  fxLayoutAlign="start center"
                  class="full-width">
                  <div class="full-width">
                    <mat-form-field class="fw nopadding nomargin">
                      <mat-label>Extra guest fee</mat-label>
                      <input
                        matInput
                        type="number"
                        maxlength="6"
                        autocomplete="off"
                        [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].extraGuestFee"
                        [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                        [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                        #extraGuestFeeMobile="ngModel" />
                      <span matSuffix>{{ listing.currency }}</span>
                    </mat-form-field>
                  </div>
                  <div class="full-width">
                    <mat-form-field class="fw nopadding nomargin">
                      <mat-label>Guests included</mat-label>
                      <input
                        matInput
                        type="number"
                        maxlength="2"
                        min="1"
                        autocomplete="off"
                        [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].guestsIncluded"
                        [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                        [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                        #guestsIncludedMobile="ngModel" />
                      <span matSuffix>Guests</span>
                    </mat-form-field>
                  </div>
                  <div class="full-width">
                    <mat-form-field class="fw nopadding nomargin">
                      <mat-label>Max occupancy</mat-label>
                      <input
                        matInput
                        type="number"
                        maxlength="2"
                        min="1"
                        autocomplete="off"
                        [(ngModel)]="propertiesRequest[pIndex].listings[lIndex].maxOccupancy"
                        [required]="propertiesRequest[pIndex].listings[lIndex].isDerived"
                        [disabled]="!propertiesRequest[pIndex].listings[lIndex].isDerived"
                        #maxOccupancyMobile="ngModel" />
                      <span matSuffix>Guests</span>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel-body>
          </mat-expansion-panel>
        </div>
      </ng-container>
    </div>
  </div>

  <div fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
    <sbnb-button
      data-intercom-target="booking-com-set-markup-skip"
      label="Skip for now"
      type="secondary"
      (click)="skip()"
      *ngIf="platform !== 'booking'"></sbnb-button>
    <sbnb-button
      data-intercom-target="booking-com-set-markup-save"
      [disabled]="!markup"
      [loading]="saving"
      label="Continue"
      (click)="progress()"></sbnb-button>
  </div>
</div>
